// This file is auto-updated or manually bumped during deployment.
// Changing this value will force all active users to reload the app.
export const APP_VERSION = "1.0.1";
